<template>
	<v-layout :class="{'align-center justify-center column mt-4': !isOnCall}" class="ma-3">
		<contact-avatar
			:size="60"
			:contact="contactInfo"
			:go-to-conversation="true"
		/>
		<div :class="isOnCall ? 'pl-4' : ''">
			<span v-if="true" class="text-subtitle-1 font-weight-bold truncate">
				{{ callLabel }} <span v-if="hasBusiness"> - {{ businessName }} </span>
			</span>

			<span v-show="isOnCall && !durationLoading" class="text-subtitle-1 font-weight-bold">
				{{ callDuration }}
			</span>
			<v-progress-circular v-show="durationLoading" size="15" color="primary" indeterminate />
		</div>
		<span
			v-if="!isOnCall"
			v-show="patientName || loadingCallDetails"
			class="text-subtitle-1 text--secondary font-weight-bold"
		>
			{{ formatPhone(phoneNumber) }}
		</span>
		<v-row class="justify-end px-3 my-1">
			<hangUp-button v-if="isOnCall" />
		</v-row>
	</v-layout>
</template>

<script>
import { phoneNumberFormater as formatPhoneNumber } from "@/common/utils";
import { mapGetters } from "vuex";
import ContactAvatar from "../../contact/ContactAvatar.vue";
import HangUpButton from "./HangUpButton.vue";

export default {
	name: "CallInfo",

	components: {
		ContactAvatar,
		HangUpButton
	},

	computed: {
		...mapGetters("voice", ["isOnCall", "activeCall", "callDetails", "loadingCallDetails"]),

		callDuration() {
			return this.activeCall?.duration;
		},

		callLabel() {
			if (this.patientName?.length) {
				return this.patientName;
			}

			return formatPhoneNumber(this.phoneNumber);
		},

		contactInfo() {
			const call = this.callDetails;

			if (!call) return ;
			return { phone: this.phoneNumber, fullname: this.patientName?.replace(/^\*\*.*?\*\*\s*/, ""), businessName: this.businessName };
		},

		hasBusiness() {
			return this.callDetails?.businessName?.length > 0;
		},

		businessName() {
			return  this.callDetails.businessName;
		},

		patientName() {
			return this.callDetails?.patientName;
		},

		phoneNumber() {
			return this.callDetails?.phoneNumber;
		},

		durationLoading() {
			return this.activeCall?.duration === "00:00" &&
			this.activeCall?.direction === "outbound";
		}
	},

	methods: {
		formatPhone(phone) {
			return formatPhoneNumber(phone);
		}
	}
};
</script>

<style scoped>
.truncate {
	word-wrap: break-word;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	word-break: break-all;
}
</style>
